import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TablePagination from '@material-ui/core/TablePagination';
import withWidth from '@material-ui/core/withWidth';

import StockDetail from '../mobile/StockDetail'
import BColor from '../BColor'
import RevList from '../details/RevList'
import MyLoveList from '../mylove/MyLoveList';
import FavoriteBorder from '@material-ui/icons/Build'
import { exportExcel } from '../util/ExportCSV'
import Divider from '@material-ui/core/Divider'

function desc(a, b, orderBy) {
    if (b.grev != undefined && a.grev != undefined && orderBy != "" && b.grev[orderBy] < a.grev[orderBy]) {
        return -1;
    }
    if (b.grev != undefined && a.grev != undefined && orderBy != "" && b.grev[orderBy] > a.grev[orderBy]) {
        return 1;
    }

    return 0;
}


function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) =>
        [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

// case class ChipPage(all : Long, sinc : Long, user : Long, uinc : Long, avgs : Double, avginc : Double, cuser : Long, cuper : Double, cincp : Double, cinc : Long, cstock : Long, csper : Double, csincp: Double)

const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: '股票代號', sid: 'name' },

    { id: 'ds', numeric: false, disablePadding: false, label: '成長率動能', sid: 'ds' },
    { id: 'ss', numeric: false, disablePadding: false, label: '成長率交叉', sid: 'ss' },
    { id: 'dr', numeric: false, disablePadding: false, label: '營收動能', sid: 'dr' },
    { id: 'sr', numeric: false, disablePadding: false, label: '營收交叉', sid: 'sr' },

    { id: 'yoy3', numeric: false, disablePadding: false, label: 'YoY', sid: 'yoy3' },
    { id: 'dyoy3', numeric: false, disablePadding: false, label: 'YoY方向', sid: 'dyoy3' },
    { id: 'avgRev3', numeric: false, disablePadding: false, label: '平均營收', sid: 'avgRev3' },
    { id: 'drev3', numeric: false, disablePadding: false, label: '平均營收方向', sid: 'drev3' },

    { id: 'yoy6', numeric: false, disablePadding: false, label: 'YoY', sid: 'yoy6' },
    { id: 'dyoy6', numeric: false, disablePadding: false, label: 'YoY方向', sid: 'dyoy6' },
    { id: 'avgRev6', numeric: false, disablePadding: false, label: '平均營收', sid: 'avgRev6' },
    { id: 'drev6', numeric: false, disablePadding: false, label: '平均營收方向', sid: 'drev6' },

    { id: 'yoy12', numeric: false, disablePadding: false, label: 'YoY', sid: 'yoy12' },
    { id: 'dyoy12', numeric: false, disablePadding: false, label: 'YoY方向', sid: 'dyoy12' },
    { id: 'avgRev12', numeric: false, disablePadding: false, label: '平均營收', sid: 'avgRev12' },
    { id: 'drev12', numeric: false, disablePadding: false, label: '平均營收方向', sid: 'drev12' },

    { id: 'love', numeric: false, disablePadding: false, label: '自選清單' },
];

const color1 = BColor.blue1color// "#e0757e"
const color2 = BColor.column
const color3 = BColor.blackcolor


function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleOk = () => {
        setOpen(false);
        props.freecashupdate()
    };

    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead style={{ background: color1 }}>
            <TableRow style={{}}>
                <TableCell className={classes.stickya1} colSpan={1} style={{ color: "#FFFFFF", borderRight: '1px solid #dbdbdb' }}>股票名稱</TableCell>
                <TableCell className={classes.stickya} colSpan={4} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">動能總表
                </TableCell>
                <TableCell className={classes.stickya} colSpan={4} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">短期營收（3個月）</TableCell>
                <TableCell className={classes.stickya} colSpan={4} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">中期營收（6個月）</TableCell>
                <TableCell className={classes.stickya} colSpan={4} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">長期營收（12個月）</TableCell>

                <TableCell className={classes.stickya} colSpan={1} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center"></TableCell>
            </TableRow>
            <TableRow style={{}}>
                {headCells.map(headCell => (
                    <TableCell
                        // style={{ margin: 0, paddingTop: 5, paddingBottom: 5, paddingLeft: headCell.paddingLeft, paddingRight: headCell.paddingRight }}
                        key={headCell.id}
                        className={(headCell.id === 'name' ? classes.stickyhh : classes.stickyh)}
                        style={{ ...((headCell.id === 'ds' || headCell.id === 'yoy3' || headCell.id === 'yoy6' || headCell.id === 'yoy12' || headCell.id === 'love') ? { borderLeft: '1px solid #dbdbdb' } : {}) }}
                        size="small"
                        align={headCell.id === 'name' ? 'left' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >{headCell.id === '0bname' || headCell.id === '1bname' || headCell.id === '2bname' || headCell.id === 'love' ? <div style={{ whiteSpace: 'nowrap' }}>{headCell.label}</div> :
                        <TableSortLabel
                            style={{ whiteSpace: 'nowrap', ...(headCell.id === 'name' ? { width: 10 } : {}), }}
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        padding: 0,
        margin: 0,
        // marginTop: theme.spacing(1),
    },
    paper: {
        width: '100%',
        backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        // maxHeight: 550,
        overflowX: 'auto'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    vvvv: {
        fontSize: 10,
        padding: 5,
        color: BColor.faircolor,
        overflow: 'visible'
    },
    button1: {
        minWidth: 110,
    },
    button2: {
        minWidth: 90,
    },
    button3: {
        minWidth: 181,
    },
    stickyc: {
        paddingLeft: 10,
        paddingRight: 5,
        width: 10,
        whiteSpace: 'nowrap',
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: 1,
        left: 0,
        backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
    },
    stickya: {
        background: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 10,
        top: 0,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0,
        borderBottom: '1px solid #dbdbdb'
    },
    stickyh: {
        backgroundColor: theme.palette.type === "light" ? color2 : "#000000",
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: 10,
        top: 37,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0
    }, //This is header
    stickya1: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 20,
        top: 0,
        left: 0,
        paddingTop: 7,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderBottom: '0px solid #dbdbdb'
    },
    stickyhh: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        top: 37,
        left: 0,
        zIndex: 20,
        paddingTop: 0,
        paddingBottom: 7,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderTop: '0px',
        borderRight: '1px solid #dbdbdb',
        borderBottom: '1px solid #dbdbdb'
    }
}));



function Rev1Table(props) {
    const classes = useStyles();
    const loveItems = localStorage.getItem('love_stock') != null ? JSON.parse(localStorage.getItem('love_stock')) : []

    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('');
    const [selected, setSelected] = React.useState(loveItems);
    const [page, setPage] = React.useState(props.currentpage);
    const [dense, setDense] = React.useState(props.dense);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.currentcount);
    const [getStock, setSavestock] = React.useState(null);

    const [opendetail, setOpendetail] = React.useState(false)
    const [stockno, setStockNo] = React.useState(null);

    const [openstock, setOpenstock] = React.useState(null);
    const [opensname, setOpenSname] = React.useState(null);
    const [concentopen, setConcentOpen] = React.useState(false);
    const [lovemenu, setLovemenu] = React.useState(false)
    const myContainer = React.useRef(null);

    const handleLoveClick = stockNo => event => {
        setSavestock(stockNo);
        setLovemenu(true);
    };

    const handleLoveClose = () => {
        setLovemenu(false);
    };

    const handleClickOpencc = (stock_no, stockName) => event => {
        setOpenstock(stock_no)
        setOpenSname(stockName)
        setConcentOpen(true);
    };

    const handleClosecc = () => {
        setOpenstock(null)
        setOpenSname(null)
        setConcentOpen(false);
    };




    function getRowPageData(screen) {
        if (screen === 'xs')
            return [20]
        else return [10, 20, 40, 80, 150];
    }

    const rows = props.data

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.stock_no);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        props.pageupdate(newPage, props.currentcount)
    };

    const handleChangeRowsPerPage = event => {
        setPage(0)
        setRowsPerPage(parseInt(event.target.value, 10));
        props.pageupdate(0, parseInt(event.target.value, 10))

        // setPage(0);
    };


    const openDetail = (stockno) => {
        if (props.detailUpdate != undefined) props.detailUpdate(true)
        setStockNo(stockno)
        setOpendetail(true)
    }

    const closeDetail = () => {
        if (props.closeupdate != undefined) props.closeupdate()
        if (props.detailUpdate != undefined) props.detailUpdate(false)
        setOpendetail(false)
    }

    function renderValueA(value, stockno, stockName) {
        let colorx = "#000205"
        let word = ''

        if (value === 0) {
            colorx = BColor.upcolorbox
            word = '持續大幅增強'
        } else if (value === 1) {
            colorx = BColor.upcolorbox
            word = '大幅增強'
        } else if (value === 2) {
            colorx = BColor.upcolorbox
            word = '小幅增強'
        } else if (value === 3) {
            colorx = BColor.downcolorbox
            word = '小幅減弱'
        } else if (value === 4) {
            colorx = BColor.downcolorbox
            word = '大幅減弱'
        } else if (value === 5) {
            colorx = BColor.downcolorbox
            word = '持續大幅減弱'
        } else {
            colorx = BColor.faircolor
            word = '-'
        }
        return <Button size="small" variant="outlined" onClick={handleClickOpencc(stockno, stockName)} style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}</Button>
    }

    function renderValueB(value, unit, stockno, stockName) {
        let colorx = "#000205"

        if (value > 0) {
            colorx = BColor.upcolorbox
        } else if (value < 0) {
            colorx = BColor.downcolorbox
        } else {
            colorx = BColor.faircolor
        }
        // {(value.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}
        return <div size="small" variant="outlined" style={{ color: colorx }} >{value}{unit}</div>
    }

    function renderValueC(value, unit, stockno, stockName) {
        // let colorx = "#000205"
        return <div size="small" variant="outlined" style={{  }}>{(value.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}{unit}</div>
    }

    function renderValueD(value, stockno, stockName) {
        let colorx = null//"#000205"
        let word = ''

        if (value === 0) {
            colorx = BColor.upcolorbox
            word = '往上'
        } else if (value === 1) {
            colorx = BColor.downcolorbox
            word = '往下'
        } else if (value === 2) {
            // colorx = "#000205"
            word = '持平'
        } else {
            // colorx = BColor.faircolor
            word = '-'
        }
        return <Button size="small" variant="outlined" onClick={handleClickOpencc(stockno, stockName)} style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}</Button>
    }

    function renderValueE(value, stockno, stockName) {
        let colorx = null// "#000205"
        let word = ''

        if (value === 0) {
            colorx = BColor.upcolorbox
            word = '金叉'
        } else if (value === 1) {
            colorx = BColor.downcolorbox
            word = '死叉'
        } else if (value === 2) {
            // colorx = "#000205"
            word = '無交叉'
        } else {
            // colorx = BColor.faircolor
            word = '-'
        }
        return <Button size="small" variant="outlined" onClick={handleClickOpencc(stockno, stockName)} style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}</Button>
    }

    const getAllIds = () => {
        return props.data.map(row => {
            return row.market_company.stock_no
        })
    }

    return (
        <div className={classes.root}>
            <StockDetail open={opendetail} allIds={getAllIds()} handleClose={closeDetail} stockno={stockno} ismobile={props.ismobile} />
            <RevList open={concentopen} handleClose={handleClosecc} stockId={openstock} stockName={opensname}></RevList>
            <MyLoveList open={lovemenu} handleClose={handleLoveClose} stockno={getStock} myloveupdate={props.myloveupdate} />

            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}
                    style={{ ...((localStorage.getItem('hfix') == null || localStorage.getItem('hfix') === "y") ? { maxHeight: '70vh' } : {}) }}
                >
                    <Table
                        ref={myContainer}
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >

                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            freecashupdate={props.freecashupdate}

                        />
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .map((row, index) => {
                                    //   const isItemSelected = isSelected(row.stock_no);

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.market_company.stock_no}
                                        >
                                            <TableCell className={classes.stickyc} style={{ borderRight: '1px solid #dbdbdb', borderBottom: '1px solid #d9d9d9' }} padding="none" size="small" align="left">
                                                <Link
                                                    component="button"
                                                    variant="body2"
                                                    onClick={() => {
                                                        openDetail(row.market_company.stock_no)
                                                    }}
                                                    color="inherit"
                                                >{row.market_company.short_name}
                                                </Link>
                                                <br />
                                                <Link
                                                    style={{ color: BColor.upcolor }}
                                                    component="button"
                                                    variant="caption"
                                                    onClick={() => openDetail(row.market_company.stock_no)}
                                                >
                                                    {row.market_company.stock_no}
                                                </Link>
                                            </TableCell>

                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 5, borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {renderValueA(row.grev.ds, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 5, borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {renderValueE(row.grev.ss, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}

                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 10 }} align="left">
                                                {renderValueA(row.grev.dr, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 5, borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {renderValueE(row.grev.sr, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}


                                            {row.grev == null || row.grev == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} colSpan="4" align="left">
                                                <Button size="small" variant="outlined" style={{ width: "100%", color: "#bdbdbd" }} className={classes.button1}>-</Button>
                                            </TableCell> : null}


                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {renderValueB(row.grev.yoy3, "%")}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="left">
                                                {renderValueD(row.grev.dyoy3, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="right">
                                                {renderValueC((row.grev.avg_rev3 / 1000000).toFixed(1), "百萬")}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="left">
                                                {renderValueD(row.grev.drev3, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev == null || row.grev == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} colSpan="4" align="left">
                                                <Button size="small" variant="outlined" style={{ width: "100%", color: "#bdbdbd" }} className={classes.button1}>-</Button>
                                            </TableCell> : null}


                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {renderValueB(row.grev.yoy6, "%")}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="left">
                                                {renderValueD(row.grev.dyoy6, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="right">
                                                {renderValueC((row.grev.avg_rev6 / 1000000).toFixed(1), "百萬")}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="left">
                                                {renderValueD(row.grev.drev6, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev == null || row.grev == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} colSpan="4" align="left">
                                                <Button size="small" variant="outlined" style={{ width: "100%", color: "#bdbdbd" }} className={classes.button1}>-</Button>
                                            </TableCell> : null}


                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {renderValueB(row.grev.yoy12, "%")}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="left">
                                                {renderValueD(row.grev.dyoy12, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="right">
                                                {renderValueC((row.grev.avg_rev12 / 1000000).toFixed(1), "百萬")}
                                            </TableCell> : null}
                                            {row.grev != null && row.grev != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }} align="left">
                                                {renderValueD(row.grev.drev12, row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.grev == null || row.grev == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10, borderLeft: '1px solid #dbdbdb' }} colSpan="4" align="left">
                                                <Button size="small" variant="outlined" style={{ width: "100%", color: "#bdbdbd" }} className={classes.button1}>-</Button>
                                            </TableCell> : null}

                                            <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 5, paddingRight: 5 }} align="center">
                                                <Button
                                                    size="small"
                                                    onClick={handleLoveClick(row.market_company.stock_no)}
                                                    variant="outlined"
                                                    style={{ width: '100%', color: BColor.faircolor }}
                                                    className={classes.button}
                                                    startIcon={<FavoriteBorder />}
                                                >
                                                    管理
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                {props.disablepage ?
                    <div><Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                        匯出
                    </Button></div>
                    : <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                        <Divider orientation="vertical" flexItem />
                        <Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                            匯出
                        </Button>
                        <Divider orientation="vertical" flexItem />
                        <TablePagination
                            rowsPerPageOptions={getRowPageData(props.width)}
                            component="div"
                            count={props.total}
                            rowsPerPage={props.currentcount}
                            page={props.currentpage}
                            labelRowsPerPage={'每頁'}
                            labelDisplayedRows={({ from, to, count }) => `第${from}筆，共 ${count}筆`}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        /></div>
                }
            </Paper>
        </div>
    );
}

export default withWidth()(Rev1Table);
